import client from '../client';
import {
  BASE_ENDPOINTS,
  RESOURCES,
  SERVICES,
  VERSIONS
} from '../common/constants';

const ENVIRONMENT_BASE = BASE_ENDPOINTS.createEndpoint(
  SERVICES.ENV,
  VERSIONS.V1,
  '',
  false // No tenant ID in the base URL
);

export const getEnvProjList = tenant_id =>
  client.get(`${ENVIRONMENT_BASE}/list/projects/${tenant_id}/`);

export const getEnvOverall = cluster =>
  client.get(`${ENVIRONMENT_BASE}/overall/${cluster}/`);

export const getEnvIndicators = cluster =>
  client.get(`${ENVIRONMENT_BASE}/metrices/${cluster}/`);
